export const blockIconsTransportationElectricRickshawNew = (
	<span className='material-symbols-outlined'>electric_rickshaw</span>
);
